import styled from 'styled-components';

import banner from '~/assets/banners/background-login.png';

export const Container = styled.div`
  > div {
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  border-radius: 0px 33px 33px 0px;

  form {
    width: 100%;

    button.btn-primary {
      border-radius: 10px !important;
      font-size: 18px;
      height: 54px;
    }
  }

  @media screen and (min-width: 992px) {
    form {
      width: 75%;
    }
  }

  @media screen and (min-width: 1600px) {
    form {
      width: 80%;
    }
  }
`;

export const Background = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
    url(${banner});
  background-size: cover;
  background-position: left center;
  position: relative;

  .logo {
    width: 105px;
  }

  @media (min-width: 992px) {
    position: absolute;
    height: 100%;
    top: 0;
    right: 0;
    flex: 0 0 auto;
    width: 61%;
    z-index: -1;
  }
`;
